import {
  FETCH_RESERVATION_LOADING,
  FETCH_RESERVATION_SUCCESS,
  FETCH_RESERVATION_ERROR
} from '../Types/thirdPartySiteTypes';

const initState = {
  data: [],
  pagination: null,
  error: null,
  success: null,
  loading: true
};

const thirdPartySiteReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_RESERVATION_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_RESERVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload.data || action.payload,
        pagination: action.payload.pagination || null
      };

    case FETCH_RESERVATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default thirdPartySiteReducer;
